import axios from 'axios'

import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { errorResponseInterceptor } from '../../../interceptors/http-interceptor/errorResponse'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'
import { basicBearerTokenRequestInterceptor } from '../../../interceptors/http-interceptor/bearerToken'

export const configureBearerTokenAPI = (url: string) => {
  const instance = axios.create({ baseURL: url })

  instance.interceptors.request.use(
    basicBearerTokenRequestInterceptor,
    errorRequestInterceptor
  )
  instance.interceptors.response.use(
    responseInterceptor,
    errorResponseInterceptor
  )

  return instance
}
